import React from 'react';
import { AdPriceDetails } from '../AdPriceDetails/AdPriceDetails';
import { Stack, Box } from 'braid-design-system';
import { PriceVisibility } from '../../utils/Product';
import { AdvertiserNation } from '../../utils/AdvertiserNation';
import { usePricingContext } from 'src/App/context/PricingContextProvider';
import { useHirerPriceVisibility } from 'src/hooks';
import { CurrentPricesDisclaimer } from '../CurrentPricesDisclaimer/CurrentPricesDisclaimer';
import { PreviewPriceAlert } from '../PreviewPriceAlert/PreviewPriceAlert';

interface PriceAttribute {
  text?: string;
  id?: number;
}

interface PriceAttributes {
  roleTitle?: string;
  subClassification?: string;
  location?: PriceAttribute;
}

interface AdPriceSummaryProps {
  advertiserId?: string;
  priceAttributes: PriceAttributes;
  advertiserNation: AdvertiserNation;
}

const AdPriceSummary = ({
  advertiserId = '',
  priceAttributes: { roleTitle = '', subClassification = '', location = {} },
  advertiserNation,
}: AdPriceSummaryProps) => {
  const { isPreview } = usePricingContext();

  const locationId =
    typeof location.id === 'string'
      ? parseFloat(location.id)
      : (location.id as number);

  const {
    isLoading: priceVisibilityLoading,
    data: priceVisibilityData,
    error: priceVisibilityError,
  } = useHirerPriceVisibility(advertiserId);

  const showDiscountedPrice =
    !isPreview &&
    !priceVisibilityLoading &&
    !priceVisibilityError &&
    priceVisibilityData === PriceVisibility.SHOW_DISCOUNTED_PRICE;

  return (
    <Box marginY="large">
      {isPreview && (
        <Box paddingBottom={'small'}>
          <PreviewPriceAlert />
        </Box>
      )}
      <Stack space={'xlarge'}>
        <AdPriceDetails
          advertiserId={advertiserId}
          roleTitle={roleTitle}
          subClassificationId={subClassification}
          locationId={locationId}
          locationText={location.text || ''}
          advertiserNation={advertiserNation}
          showDiscountedPrice={showDiscountedPrice}
        />
        <CurrentPricesDisclaimer showDiscountedPrice={showDiscountedPrice} />
      </Stack>
    </Box>
  );
};

export {
  type PriceAttribute,
  type PriceAttributes,
  AdPriceSummary,
  type AdPriceSummaryProps,
};
